export default __webpack_public_path__ + "static/test_2_4_ru-12108a6b15350ed6e00af68230626544.png";